import axiosInstance from "../lib/axios";

interface GetSalesRequest {
  page?: number;
  limit?: number;
}

interface Sales {
  id: number;
  name: string;
  phone: string;
  nik: string;
  email: string;
  address: string;
  emergency_contact: string;
  status: string;
}

export const getSales = async ({
  page = 1,
  limit = 10,
}: GetSalesRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/Sales/List", body);

  return data;
};

export const createsales = (data: {
  name: string;
  phone: string;
  nik: string;
  email: string;
  address: string;
  emergency_contact: string;
  status: string;
}) => {
  return axiosInstance.post("/Sales/Create", data);
};

export const getsalesById = (id: number) => {
  return axiosInstance.get(`/Sales/${id}`);
};

export const editsales = (id: number, data: any) => {
  return axiosInstance.put(`/Sales/${id}`, data);
};

export const deletesalesById = (id: number) => {
  return axiosInstance.delete(`/Sales/${id}`);
};

